const ContactIcon = ({ fill = "#1B1B1B", width = 32 }) => (
  <svg
    width={width}
    viewBox="0 0 78 62"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
  >
    <path d="M75,0 C76.656854,0 78,1.343146 78,3 L78,59 C78,60.656854 76.656854,62 75,62 L3,62 C1.343146,62 0,60.656854 0,59 L0,3 C0,1.343146 1.343146,0 3,0 L75,0 Z M76,2 L39,30 L2,2 L2,58 C2,59.054362 2.815878,59.918165 3.850738,59.994514 L4,60 L74,60 C75.054362,60 75.918165,59.184122 75.994514,58.149262 L76,58 L76,2 Z M73,2 L5,2 L39,27 L73,2 Z" />
  </svg>
);

export default ContactIcon;